module.exports = __webpack_public_path__ + "apple-icon-120x120.6b374c8e.png";